import { useMemo } from "react";
import { useOrder } from "../../hooks/queries/useOrder";

import { ProductsTable } from "../../styles/common";

import NoProductResult from "./components/NoProductResult";
import LoadingResults from "../LoadingResults";
import ResultItem from "./components/ResultItem";
import Product from "types/Product";
import OrderItem from "types/OrderItem";
import { ItemToSendSimple } from "../../types/ItemToSend";

interface ProductListProps {
  loading?: boolean;
  products?: Product[];
  onQtChange: (product: Product, qtd: number) => void;
  itemsOnOrder?: OrderItem[];
  itemsToSend: ItemToSendSimple[];
  rowHighlight?: boolean;
}

const ProductList = ({
  loading: loadingProp,
  products: productsProp,
  onQtChange,
  itemsOnOrder: itemsOnOrderProp,
  itemsToSend,
  rowHighlight = false,
}: ProductListProps) => {
  // Usa React Query para buscar items do pedido se não fornecidos via props
  const { data: orderData } = useOrder();
  const itemsOnOrderFromQuery = orderData?.items || [];
  const itemsOnOrder = itemsOnOrderProp || itemsOnOrderFromQuery;

  // Otimização: Criar Maps para lookup O(1) ao invés de loops O(n²)
  const itemsOnOrderMap = useMemo(
    () =>
      new Map(
        (itemsOnOrder || []).map(item => [item.cd_mercadoria, item.qt_pedida])
      ),
    [itemsOnOrder]
  );

  const itemsToSendMap = useMemo(
    () => new Map(itemsToSend.map(item => [item.cd_mercadoria, item.qtd])),
    [itemsToSend]
  );

  return (
    <ProductsTable>
      <thead>
        <tr>
          <th>Cód.</th>
          <th>Inf.</th>
          <th>Mercadoria</th>
          <th>Qtd</th>
          <th>Preço líq.</th>
          <th>Imposto</th>
          <th>Preço final com ST</th>
        </tr>
      </thead>
      <tbody>
        {loadingProp && <LoadingResults />}
        {!loadingProp && (productsProp || []).length === 0 ? (
          <NoProductResult colSpan={7} />
        ) : (
          (productsProp || []).map(product => {
            const qtdOnOrder = itemsOnOrderMap.get(product.cd_mercadoria) || 0;
            const qtyAsked = itemsToSendMap.get(product.cd_mercadoria) || "";

            return (
              <ResultItem
                key={product.cd_mercadoria}
                qtdOnOrder={qtdOnOrder}
                onQtChange={onQtChange}
                product={product}
                value={qtyAsked}
                rowHighlight={rowHighlight}
              />
            );
          })
        )}
      </tbody>
    </ProductsTable>
  );
};

export default ProductList;
